module.exports = __webpack_public_path__ + "static/media/brush-14@1x.8894b6aa.png";